import { render, staticRenderFns } from "./WeekTime.vue?vue&type=template&id=56437aa0&scoped=true"
import script from "./WeekTime.vue?vue&type=script&lang=js"
export * from "./WeekTime.vue?vue&type=script&lang=js"
import style0 from "./WeekTime.vue?vue&type=style&index=0&id=56437aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56437aa0",
  null
  
)

export default component.exports